import * as React from 'react';

import { SVGComponentProps } from './svg.types';

const MoreSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 14 4"
        xmlns="http://www.w3.org/2000/svg"
        {...otherProps}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.2161 3.75C12.5622 3.75 12.9005 3.64736 13.1883 3.45507C13.4761 3.26278 13.7004 2.98947 13.8329 2.6697C13.9653 2.34993 14 1.99806 13.9324 1.65859C13.8649 1.31913 13.6982 1.00731 13.4535 0.762564C13.2088 0.517822 12.8969 0.351151 12.5575 0.283627C12.218 0.216102 11.8661 0.250758 11.5464 0.383212C11.2266 0.515665 10.9533 0.739967 10.761 1.02775C10.5687 1.31554 10.4661 1.65388 10.4661 2C10.4659 2.22985 10.5111 2.45747 10.599 2.66985C10.6869 2.88223 10.8158 3.0752 10.9783 3.23773C11.1409 3.40026 11.3338 3.52916 11.5462 3.61706C11.7586 3.70496 11.9862 3.75013 12.2161 3.75ZM6.96606 3.75C7.31218 3.75 7.65053 3.64736 7.93831 3.45507C8.2261 3.26278 8.4504 2.98947 8.58285 2.6697C8.71531 2.34993 8.74996 1.99806 8.68244 1.65859C8.61491 1.31913 8.44824 1.00731 8.2035 0.762564C7.95876 0.517822 7.64694 0.351151 7.30747 0.283627C6.96801 0.216102 6.61614 0.250758 6.29637 0.383212C5.9766 0.515665 5.70329 0.739967 5.51099 1.02775C5.3187 1.31554 5.21606 1.65388 5.21606 2C5.21593 2.22985 5.26111 2.45747 5.34901 2.66985C5.43691 2.88223 5.56581 3.0752 5.72833 3.23773C5.89086 3.40026 6.08383 3.52916 6.29621 3.61706C6.50859 3.70496 6.73621 3.75013 6.96606 3.75ZM1.71606 3.75C2.06218 3.75 2.40053 3.64736 2.68831 3.45507C2.9761 3.26278 3.2004 2.98947 3.33285 2.6697C3.46531 2.34993 3.49996 1.99806 3.43244 1.65859C3.36491 1.31913 3.19824 1.00731 2.9535 0.762564C2.70876 0.517822 2.39694 0.351151 2.05747 0.283627C1.71801 0.216102 1.36614 0.250758 1.04637 0.383212C0.726598 0.515665 0.453285 0.739967 0.260993 1.02775C0.0687004 1.31554 -0.0339353 1.65388 -0.0339353 2C-0.0340667 2.22985 0.0111087 2.45747 0.0990078 2.66985C0.186907 2.88223 0.315806 3.0752 0.478335 3.23773C0.640863 3.40026 0.833834 3.52916 1.04621 3.61706C1.25859 3.70496 1.48621 3.75013 1.71606 3.75Z"
          fill={fill}
        />
      </svg>
    </span>
  );
};

export default MoreSVG;
